<app-dropdown>
  <div dropdownTrigger>
    <button-component
      [text]="userData().user.name"
      customId="user-header-button"
      [tmobBtnStyle]="userHeaderButton"
      sizeButton="btn-size-M"
    />
  </div>

  <div class="header-user-dropdown-content" dropdownContent #dropdownContent>
    <div class="header-user-dropdown-content-section">
      <span class="header-user-dropdown-content-section-label-dropdown">
        {{ userData().user.name }}
      </span>
      <span class="header-user-dropdown-content-section-info">{{
        getUserRolesLabel()
      }}</span>

      @if (userData().user.lastAccess !== null) {
        <div
          class="header-user-dropdown-content-section-label-dropdown-lastAccess-wrapper"
        >
          <span>{{ gencatHeaderConfig.lastAccessMessage | translate }}</span>
          <span>{{
            userData().user.lastAccess | date: "dd/MM/yyyy" : "Europe/Madrid"
          }}</span>
        </div>
      }
    </div>
    <div class="header-user-dropdown-content-section">
      <div
        class="header-user-dropdown-content-section-label-dropdown-preferences"
      >
        <span
          class="header-user-dropdown-content-section-label-dropdown-preferences-text"
          >{{ gencatHeaderConfig.setPreferencesMessage | translate }}</span
        >
        <i
          class="bi bi-arrow-right header-user-dropdown-content-section-label-dropdown-preferences-icon"
          (click)="changePreferences()"
        ></i>
      </div>
      <span class="header-user-dropdown-content-section-info"
        >{{ gencatHeaderConfig.seeLanguageMessage | translate }}
        {{ currentLanguageSignal() }}</span
      >
    </div>
    <div class="header-user-dropdown-close-session-section">
      <button-component
        appDropdownClose
        [text]="gencatHeaderConfig!.logOutMessage!"
        customId="user-header-button-close-session"
        [tmobBtnStyle]="tertiaryButton"
        (click)="closeSessionFromBanner()"
      ></button-component>
    </div>
  </div>
</app-dropdown>
